var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["header/cart-count.j2"] = require( "header/cart-count.j2" );
dependencies["header/cart-image.j2"] = require( "header/cart-image.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/header/cart.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/header/cart.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("checkoutUrl")) {
var t_4 = t_1.checkoutUrl;
} else {
cb(new Error("cannot import 'checkoutUrl'")); return;
}
context.setVariable("checkoutUrl", t_4);
output += "<a ";
output += runtime.suppressValue((lineno = 2, colno = 6, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["top_nav","Cart"])), env.opts.autoescape);
output += " href=\"";
output += runtime.suppressValue((lineno = 2, colno = 45, runtime.callWrap(t_4, "checkoutUrl", context, [])), env.opts.autoescape);
output += "\" rel=\"nofollow\" class=\"c-cart__a dom-cart__a js-cart-link\" aria-label=\"";
output += runtime.suppressValue((lineno = 2, colno = 122, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["cart-count-shopping-cart"])), env.opts.autoescape);
output += "\">\n\n    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"cart")),"bagCount")) {
output += "\n\n        ";
env.getTemplate("header/cart-count.j2", false, "core/templates/header/cart.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n\n    ";
})});
}
output += "\n\n    ";
env.getTemplate("header/cart-image.j2", false, "core/templates/header/cart.j2", null, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
t_9.render(context.getVariables(), frame, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
output += t_10
output += "\n\n</a>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/header/cart.j2"] , dependencies)